import { render, staticRenderFns } from "./TaskChecklists.vue?vue&type=template&id=7fd5850c&"
import script from "./TaskChecklists.vue?vue&type=script&lang=js&"
export * from "./TaskChecklists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports